import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import BgContain from './images/abctract-wooden-texure-closeup-background.jpg'

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100% !important;
    margin-top: 40px;
    text-align: center;
    position: relative;
    @media screen and (max-width: 768px) {
    display: none;
  }
    `;
export const Title = styled.h1`
  font-weight: 700;
  float: left;
  line-height: 4rem;
  padding-left: 15px;
  padding-bottom: 5px;
  color: ${themeGet("colors.primary", "#9cc54b")};
  @media (max-width: 767px){
    font-size: 2rem;
  }
  `;

export const BgWrapper = styled.div`
  background-image: url(${BgContain});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  // display: grid;
  // grid-template-columns: repeat(6,1fr);
  padding: 30px 30px 50px;

  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1.4rem;
  // @media screen and (max-width: 1300px) {
  //   grid-template-columns: repeat(5,1fr);
  // }
  // @media screen and (max-width: 1199px) {
  //   grid-template-columns: repeat(4,1fr);
  // }
  //  @media screen and (max-width: 880px) {
  //   grid-template-columns: repeat(3,1fr);
  // }
`;